import {
  LOGIN,
  LOGIN_ERROR,
  LOGOUT,
  LOGOUT_ERROR,
  RESET_STORE,
  CHANGE_LOGIN_STATUS,
  CLEAN_STORE,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_ERROR,
  MANUALLY_TRIGGER_AUTENTICATION,
  RESET_PASSWORD,
  RESET_PASSWORD_ERROR
} from "../types";

export const loginReducer = (state = {}, action) => {
  switch (action.type) {
    case LOGIN:
      return { ...state, loggedIn: true, login: action.payload };
    case LOGIN_ERROR:
      return { ...state, loggedIn: false, loginError: action.payload };
    case LOGOUT:
      return { ...state, logout: action.payload };
    case LOGOUT_ERROR:
      return { ...state, logoutError: action.payload };
    case CHANGE_LOGIN_STATUS:
      return { ...state, loggedIn: false };
    case CLEAN_STORE:
      return { ...state, cleanStore: action.payload };
    case FORGOT_PASSWORD:
      return { ...state, forgotPasswordMessage: action.payload.message };
    case FORGOT_PASSWORD_ERROR:
      return { ...state, forgotPasswordMessage: action.payload.message };
    case RESET_PASSWORD:
      return { ...state, resetPasswordMessage: action.payload.message };
    case RESET_PASSWORD_ERROR:
      return { ...state, resetPasswordMessage: action.payload.message };
    case MANUALLY_TRIGGER_AUTENTICATION:
      return { ...state, autenticated: action.payload };
    /*case RESET_STORE{:
      return (state = });*/
    default:
      return state;
  }
};
